var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card text-center"},[_vm._m(0),_c('div',{staticClass:"p-2"},[_c('div',{staticClass:"mb-4"},[_c('div',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.open}},[_vm._v("Assign route")])],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-content-center align-items-center p-4 m-2"},[_c('h4',{},[_vm._v("No routes assigned yet")])])
}]

export { render, staticRenderFns }